<template>
  <layout :lead="leadInfo" :rooftop="rooftopInfo" :welcome-message="welcomeMessage">
    <section class="finance-content-section">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-xs-12 col-sm-8 col-md-8 col-lg-6 pl-lg-0">
            <video-box-list :categories="contents.categories || []" />
          </div>
        </div>
      </div>
    </section>
  </layout>
</template>

<script>
import { mapState } from 'vuex';
import Layout from '@/layouts/default';
import VideoBoxList from '@/components/video-box-list';
import { PAGE_TITLES } from '@/constants';

export default {
  name: 'FinanceProducts',
  metaInfo: {
    title: PAGE_TITLES['finance-products'],
  },
  components: {
    Layout,
    VideoBoxList,
  },
  data() {
    return {
      welcomeMessage:
        'Take a few minutes to learn about the importance of protecting your investment.',
    };
  },
  computed: {
    ...mapState(['contents', 'leadInfo', 'rooftopInfo']),
  },
};
</script>
